var _desc, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRunityLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 370,
    height: 100,
    viewBox: "0 0 370 100",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "RUNITY") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Run with Integrity logo")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 10)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 36,
    fill: "none",
    stroke: "#e5e5ea",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 28,
    fill: "none",
    stroke: "#1d1d1f",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 40 L37 51 L54 30",
    fill: "none",
    stroke: "#7bf100",
    strokeWidth: 3.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 31,
    x2: 16,
    y2: 31,
    stroke: "#1d1d1f",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 40,
    x2: 14,
    y2: 40,
    stroke: "#1d1d1f",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 49,
    x2: 15,
    y2: 49,
    stroke: "#1d1d1f",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(105 16)",
    fontFamily: "Arial, Helvetica, 'Malgun Gothic', sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 38,
    fill: "#1d1d1f",
    fontSize: 36,
    fontWeight: 900,
    letterSpacing: 5
  }, "RUN"), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 4,
    width: 93,
    height: 45,
    rx: 8,
    fill: "#7bf100"
  }), /*#__PURE__*/React.createElement("text", {
    x: 124,
    y: 38,
    fill: "#1d1d1f",
    fontSize: 36,
    fontWeight: 900,
    letterSpacing: 5
  }, "ITY"), /*#__PURE__*/React.createElement("text", {
    x: 1,
    y: 69,
    fill: "#86868b",
    fontSize: 15,
    fontWeight: 600,
    letterSpacing: 5.2
  }, "Run with Integrity"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunityLogo);
export default __webpack_public_path__ + "static/media/runity-logo.0395ae4cbb60862a0850bc7c62b09f77.svg";
export { ForwardRef as ReactComponent };